import theme1 from "./themes/theme1";
import theme2 from "./themes/theme2";
import theme3 from "./themes/theme3";
import sirvDefault from "./themes/default";

export const themes = [sirvDefault, theme1, theme2, theme3];

export const getThemeByName = (name) =>
  themes.find((theme) => theme.name === name);
